import { useMutation } from "urql";

import { RunAiPromptDocument } from "../../../../graphql/generated.ts";

export function useRunAIPrompt() {
  return useMutation(RunAiPromptDocument);
}
